import { Router } from '@angular/router';
import moment from 'moment';
import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Subscription, timer } from 'rxjs';
import { DataMonitoringReportServiceResult } from './../model/data-monitoring-report-service-result.model';
import { County } from 'src/app/model/county';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { Region } from 'src/app/model/region.model';
import { School } from 'src/app/model/school.model';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { DataMonitoringService } from './../service/data-monitoring.service';
import { environment } from 'src/environments/environment';

import { UtilityService } from '../../../service/utility.service';
import { ApiExportsService } from 'src/app/service/api-exports.service';
import { UrlProviderService } from 'src/app/service/urlprovider.service';
import { RegionDropdownComponent } from '../../common-components/region/region-dropdown/region-dropdown.component';
import { CountyDropdownComponent } from '../../common-components/county/county-dropdown/county-dropdown.component';
import { DistrictDropdownComponent } from '../../common-components/district/district-dropdown/district-dropdown.component';
import { DtMonService } from '../service/dtmon.service';
import { SchoolDropdownComponent } from '../../common-components/school/school-dropdown/school-dropdown.component';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ThemePalette } from '@angular/material/core';

@Component({
    selector: 'app-data-monitoring-services',
    templateUrl: './data-monitoring-services.component.html',
    styleUrls: ['./data-monitoring-services.component.scss']
})
export class DataMonitoringServicesComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    @ViewChild('appRegionCode') appRegionCode!: RegionDropdownComponent;
    @ViewChild('appCountyCode') appCountyCode!: CountyDropdownComponent;
    @ViewChild('appDistrictCode') appDistrictCode!: DistrictDropdownComponent;
    @ViewChild('appSchools') appSchools!: SchoolDropdownComponent;
    @ViewChild(MatTable, { read: ElementRef }) table?: ElementRef<HTMLElement>;
    @Input() searchParm: any = [{}];
    public data: { sIds: number[]; performancePeriod: string; mpoNumber: number; fileNameLabel: string };
    isLoadingResults: boolean = false;
    isExporting: boolean = false;

    progressCurrentValue: number = 10;
    progressValue: number = 10;
    progressMax: number = 200;
    progressSpinnerMax: number = 100;
    progressColor: ThemePalette = 'accent';
    progressType: ProgressSpinnerMode = 'determinate';
    progressSpeed: number = 50;

    progressSubscription: Subscription;
    progressInterval: number = 500;
    lstStudentsServiceResultResponseDataView: DataMonitoringReportServiceResult[] = [];
    strExportFileName = 'Missing_Service_End_Date';
    fileNameLabel: string = '';
    bCheckedStyling: boolean = true;

    settings: any = {
        '/data-monitoring-reports/missing-service-end-date': {
            TITLE: 'Missing Service End Date',
            EXPORTFILENAME: 'Missing_Service_End_Date',
            API: undefined,
            SCHOOL_YEAR: true,
            PERFORMANCE_PERIOD: false,
            HELP_TEXT_ID: 'DataMonitoring_MissingServiceEndDate_Overview',
            COLUMN_HEADERS: ['Region', 'School District', 'School', 'MSDNumber', 'Name', 'DOB', 'Service Name', 'Service Code', 'Service Period', 'EOE'],
            COLUMN_WIDTHS: [25, 70, 70, 50, 80, 30, 60, 45, 45, 35],
            COLUMNS: [
                'RegionCode',
                'SchoolDistrict',
                'SchoolName',
                'MsdNumber',
                'LastName',
                'DOB',
                'ServiceName',
                'ServiceCode',
                'ServicePeriod',
                'EligibilityEndDate'
            ]
        },
        '/data-monitoring-reports/duplicate-service': {
            TITLE: 'Duplicate Services',
            API: undefined,
            EXPORTFILENAME: 'Duplicate_Services',
            SCHOOL_YEAR: true,
            PERFORMANCE_PERIOD: false,
            HELP_TEXT_ID: 'DataMonitoring_DuplicateServices_Overview',
            COLUMN_HEADERS: [
                'Region Code',
                'School Year',
                'School District',
                'School',
                'Grade',
                'MSDNumber',
                'Name',
                'DOB',
                'Service Name',
                'Service Code',
                'Service Period'
            ],
            COLUMN_WIDTHS: [40, 40, 100, 100, 25, 50, 75, 30, 45, 45, 35],
            COLUMNS: [
                'RegionCode',
                'SchoolYear',
                'SchoolDistrict',
                'SchoolName',
                'Grade',
                'MsdNumber',
                'LastName',
                'DOB',
                'ServiceName',
                'ServiceCode',
                'ServicePeriod'
            ]
        }
    };
    currentSetting: any;

    // Search variables
    selectedSchoolYear: string = '';
    initialSchoolYear: string = '';
    currentSchoolYear: string = '';
    selectedSchool: string = '';
    selectedPerformancePeriod: string = '';
    initialPerformancePeriod: string = '';
    currentPerformancePeriod: string = '';
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    chosenSchools: School[] = [];
    chosenSchoolYear: string = '';

    startingSchoolYearDate: Date;

    // Component variables
    resetField: boolean = false;

    // Table display
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns

    // Table results
    tableDataSource!: MatTableDataSource<DataMonitoringReportServiceResult>;
    lstSearchServiceResponseDataView: DataMonitoringReportServiceResult[] = [];

    // Results
    results: DataMonitoringReportServiceResult[] = [];
    filter: string = '';

    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    constructor(
        private dataMonitoringService: DataMonitoringService,
        public dtMonService: DtMonService,
        router: Router,
        private dialog: MatDialog,
        //  public routeGuardService: RouteGuardService,
        private urlProvider: UrlProviderService,
        private utilityService: UtilityService,
        private apiMsinExportsService: ApiExportsService
    ) {
        this.connectAPIs(dataMonitoringService);
        this.selectSettings(router.url);
        this.setStartingSchoolYearDate();
    }

    connectAPIs(dataMonitoringService: DataMonitoringService) {
        this.settings['/data-monitoring-reports/missing-service-end-date'].API = function (payload: any) {
            return dataMonitoringService.getMissingServiceEndDate(payload);
        };

        this.settings['/data-monitoring-reports/duplicate-service'].API = function (payload: any) {
            return dataMonitoringService.getDuplicateService(payload);
        };
    }

    selectSettings(url: string) {
        this.currentSetting = this.settings[url];
    }

    setStartingSchoolYearDate() {
        // Set the cut-off day to go to next school year (the week after the 3rd Friday in Sept)
        let mDate = moment({ month: 8, day: 1 }); // month is 0 based

        // By default we will need to add two weeks to the first friday
        let nWeeks = 2;
        let month = mDate.month();

        // Get first Friday of the first week of the month
        mDate = mDate.date(1).day(5);

        // Check if first Friday is in the given month
        //  it may have gone to the previous month
        if (mDate.month() != month) {
            nWeeks++;
        }

        this.startingSchoolYearDate = mDate.add(nWeeks, 'weeks').add(3, 'days').toDate();
    }

    ngOnInit(): void {}

    search() {
        if (this.checkValid()) {
            this.isLoading = true;
            this.msg = {};
            this.filter = '';

            this.currentSetting.API(this.generatePayload()).subscribe({
                next: (res: any) => {
                    if (res.students) {
                        this.results = res.students.sort((n1: DataMonitoringReportServiceResult, n2: DataMonitoringReportServiceResult) =>
                            n1.LastName! > n2.LastName! ? 1 : -1
                        );

                        this.displayedColumns = this.currentSetting.COLUMNS;

                        // Updates the Tables to be displayed w/ this.results
                        this.updateDataSource();
                    } else if (res.msg) {
                        this.results = [];
                        this.msg = res.msg;
                    } else {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving ' + this.currentSetting.TITLE + '.' };
                    }
                },
                error: (err: any) => {
                    this.results = [];
                    this.msg = { SUCCESS: false, MSG: 'Error retrieving ' + this.currentSetting.TITLE + '.' };
                },
                complete: () => {
                    // Display current performance period
                    this.currentSchoolYear = this.selectedSchoolYear;
                    this.currentPerformancePeriod = this.selectedPerformancePeriod;

                    // Display results
                    this.isLoading = false;
                }
            });
        }
    }

    generatePayload(): any {
        let payload: any = {};

        payload.chosenRegions = this.toNumberArray(this.chosenRegions);
        payload.chosenCounties = this.toNumberArray(this.chosenCounties);
        payload.chosenSchoolDistricts = this.toNumberArray(this.chosenSchoolDistricts);
        payload.chosenSchools = this.toNumberArray(this.chosenSchools);
        payload.schoolYear = this.selectedSchoolYear;
        payload.performancePeriod = this.selectedPerformancePeriod;

        return payload;
    }

    updateDataSource() {
        setTimeout(() => {
            // Data
            this.tableDataSource = new MatTableDataSource<DataMonitoringReportServiceResult>();
            this.tableDataSource.data = this.results;

            // Paginator
            this.tableDataSource.paginator = this.paginators.toArray()[0];

            // Sort
            this.tableDataSource.sort = this.sorts.toArray()[0];
            const defaultSort: Sort = { active: 'MsdNumber', direction: 'asc' };
            this.tableDataSource.sort.active = defaultSort.active;
            this.tableDataSource.sort.direction = defaultSort.direction;
            this.tableDataSource.sort.sortChange.emit(defaultSort);
            this.tableDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

            // Filter
            this.tableDataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };
        });
    }

    setFilter() {
        this.tableDataSource.filter = this.filter.trim().toLocaleLowerCase();
    }

    checkValid() {
        if (this.chosenRegions.length > 0 && (this.selectedSchoolYear || this.selectedPerformancePeriod)) {
            return true;
        }

        return false;
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }

    schoolYearEvent(schoolYear: string) {
        this.selectedSchoolYear = schoolYear;
    }

    performancePeriodEvent(performancePeriod: string) {
        this.selectedPerformancePeriod = performancePeriod;
    }

    // MISC
    reset() {
        this.resetField = !this.resetField;
        //This is optional code To resetthe value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        this.chosenRegions = [];
        this.chosenCounties = [];
        this.chosenSchoolDistricts = [];
        this.chosenSchools = [];

        this.msg = {};
    }

    downloadExcel() {
        this.isExporting = true;
        this.msg = new MsgModel();

        let payload: any = this.generateExportPayload(this.currentSetting.EXPORTFILENAME);

        this.apiMsinExportsService.exportDataMonitoringReport(payload).subscribe({
            next: (res2: any) => {
                const blob = new Blob([res2], { type: 'application/xlsx' });

                let fileName = this.utilityService.fnMakeFileNameTime(this.currentSetting.EXPORTFILENAME);

                const renamedFile = new File([blob], fileName, { type: blob.type, lastModified: Date.now() });

                const url = URL.createObjectURL(renamedFile);

                const a = document.createElement('a');
                a.href = url;
                fileName = fileName.trimLeft();

                a.download = fileName + '.xlsx';
                a.click();
                if (a && a.parentNode === document.body) {
                    document.body.removeChild(a);
                }

                URL.revokeObjectURL(url);
            },
            error: (e) => {
                this.msg = { SUCCESS: false, MSG: 'Error exporting Counts Report.' };
                this.isExporting = false;
            },
            complete: () => {
                this.isExporting = false;
            }
        });
    }

    generateExportPayload(exportName: string) {
        let payload = {
            settings: {
                headerNames: this.generateHeaderNames(),
                exportName: exportName
            },
            data: this.tableDataSource.data
        };

        return payload;
    }

    generateHeaderNames() {
        if (!this.table) {
            return [];
        }

        return Array.from(this.table.nativeElement.querySelectorAll('.mat-sort-header-content')).map((th) => th.textContent?.trim() ?? '');
    }
}
